export default __webpack_public_path__ + "resources/icons/n330-5fc8.png";